import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component for Mobile Call Awareness Phase 1 (CONEK-4042/4043).
//
// On Android, sends `arm` to the native shell when the user's active
// MobileProfile carries the `calls.auto_record` capability so
// CallCaptureService records subsequent calls (skipped natively without
// the microphone permission, CONEK-8007). Sends `disarm` on `disconnect()`
// so leaving the page reliably stops the background recording state. iOS receives the `arm` message too
// but the iOS shell ignores it (Apple does not allow third-party call
// recording) and surfaces the manual-log form via `bridge--call-log`.
//
// `arm` carries the page's CSRF token: CallUploader POSTs the recording to
// /api/v1/telephony/call_sessions with the WebView session cookie, and the API
// enforces CSRF on cookie-authenticated writes (CONEK-5579), so without it
// every upload is rejected with 422 csrf_token_invalid (CONEK-8007).
export default class extends BridgeComponent {
  static component = "call-capture"

  static values = {
    armed: { type: Boolean, default: false },
    userId: String,
    profileSlug: String,
  }

  connect() {
    super.connect()
    if (!this.armedValue) return

    this.send("arm", {
      user_id: this.userIdValue,
      profile_slug: this.profileSlugValue,
      csrf_token:
        document.querySelector('meta[name="csrf-token"]')?.content ?? "",
    })
  }

  disconnect() {
    if (this.armedValue) {
      this.send("disarm", {
        user_id: this.userIdValue,
      })
    }
    super.disconnect()
  }
}
